<template>
  <!--
    Toasts sit bottom-right by default. They render in the document
    `<body>` (outside the `#app` subtree) via `<Teleport>`, so they
    paint after — and unambiguously above — every in-app surface
    regardless of stacking context. This matters because a `<ToolDock>`
    uses `backdrop-blur-sm`, and a `backdrop-filter` element can
    composite over higher-`z-index` siblings inside the same subtree
    (a known browser quirk); teleporting out of `#app` sidesteps it so
    z-order alone keeps the toast on top — even when it visually
    overlaps an open dock.

    `positionClass` still lifts the toast clear of an open dock so they
    don't sit on top of each other cosmetically, but it is no longer
    load-bearing for visibility. The auth layout has no dock and no
    `--app-header-h` header, so it stays top-5.
  -->
  <Teleport to="body">
    <div
      class="fixed right-5 z-toast isolate flex flex-col items-end space-y-2"
      :class="positionClass"
    >
      <transition-group name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          @click="() => removeToast(toast.id)"
          class="px-4 py-3 rounded shadow pointer-events-auto cursor-pointer max-w-[360px] flex items-center space-x-3"
          :class="{
            'bg-green-500 text-white': toast.type === 'success',
            'bg-red-500 text-white': toast.type === 'error',
            'bg-yellow-500 text-white': toast.type === 'warning',
            'bg-blue-500 text-white': toast.type === 'info',
          }"
        >
          <span class="text-base">{{ toast.message }}</span>
        </div>
      </transition-group>
    </div>
  </Teleport>
</template>

<script src="./toast.component.ts" lang="ts" />

<style>
.toast-leave-active {
  transition:
    opacity 0.5s,
    transform 0.5s;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(10px);
}
</style>
